// extracted by mini-css-extract-plugin
module.exports = {"selected-tag":"styles_selected-tag__S7bbr","trending-image":"styles_trending-image__oCOB1"};